import { Project } from "./project";

export class YearProject {
  year: string;
  project_id: string;

  // External data
  project: Project = null;

  constructor(year: string, project_id: string) {
    this.year = year;
    this.project_id = project_id;
  }

  public static createInstance(jsonData: YearProject): YearProject {
    const d = Object.assign(new YearProject(jsonData.year, jsonData.project_id), jsonData);
    if (d.project) {
      d.project = Project.createInstance(d.project);
    }
    return d;
  }

  public static createInstances(jsonData: any[]): YearProject[] {
    return jsonData.map(YearProject.createInstance);
  }

  clone(): YearProject {
    return new YearProject(this.year, this.project_id);
  }
}

export class RenewProject {
  renew_project_id: string;
  name: string;
  eva_company_id: string;
  years_projects: YearProject[];

  getYears(): string[] {
    return this.years_projects.map((y) => y.year);
  }

  public static createInstance(jsonData: RenewProject): RenewProject {
    const d = Object.assign(new RenewProject(), jsonData);
    if (d.years_projects) {
      d.years_projects = YearProject.createInstances(d.years_projects);
    }
    return d;
  }

  public static createInstances(jsonData: any[]): RenewProject[] {
    return jsonData.map(RenewProject.createInstance);
  }

  clone(): RenewProject {
    let d = Object.assign(new RenewProject(), this);
    if (d.years_projects) {
      d.years_projects = this.years_projects.map((y) => y.clone());
    }
    return d;
  }
}
